module.exports = __webpack_public_path__ + "static/007495-24a4e79b0d2fd62f2a475a01c28d2f2f.jpg";